<template>
    <div class="collapsible">
        <button
            class="collapsible__header"
            @click="isCollapsed = !isCollapsed"
            :aria-expanded="!isCollapsed"
            type="button"
        >
            <span
                class="mdi"
                :class="{'mdi-chevron-down': isCollapsed, 'mdi-chevron-up': !isCollapsed}"
                aria-hidden="true"
            ></span>
            <slot></slot>
        </button>
        <div
            class="collapsible__body"
            v-if="!isCollapsed"
            id="collapsible-body"
            role="region"
            :aria-labelledby="'collapsible-header'"
        >
            <slot name="body"></slot>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Collapsible',

    data () {
        return {
            isCollapsed: true
        }
    }
}
</script>

<style lang="scss">
    .collapsible {
        padding: 20px 0;
        border-top: 1px solid #f3f3f3;
        border-bottom: 1px solid #f3f3f3;
        margin-top: -1px;

        &__header  {
            position: relative;
            padding-right: 20px;
            margin-top: 10px;
            cursor: pointer;
            border: none;
            background-color: transparent;
            width: 100%;

            > .mdi {
                position: absolute;
                right: 0;
                top: 0;

                font-size: 120%;
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/elements/Collapsible.vue